import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      light: '#ff7154',
      main: '#ef4623',
      dark: '#d04123',
      contrastText: '#fff',
    },
  },
});

export default theme;
